import { ENV } from './env';

// AWS Amplify v6 configuration format
const cognito = {
  Auth: {
    Cognito: {
      userPoolId: ENV.cognitoUserPoolId,
      userPoolClientId: ENV.cognitoClientId,
      loginWith: {
        oauth: {
          domain: ENV.cognitoDomain,
          scopes: ['email', 'openid'], // FIXME: add 'profile' to the scope when available
          redirectSignIn: [ENV.callbackUrl || window.location.origin],
          redirectSignOut: [ENV.callbackUrl || window.location.origin],
          responseType: 'code',
        },
      },
    },
  },
};

export default cognito;
